import { PoiListAdminResolver } from './resolvers/poi-list-admin.resolver';
import { CoreModule } from './core/core.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './pages/home/home.component';
import { NavComponent, LogoutDialogContent, LoginDialogContent, SuccessLoginComponent } from './nav/nav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { MapComponent } from './pages/map/map.component';
import { ListaPoiComponent } from './pages/lista-poi/lista-poi.component';
import { PoiSingoloComponent, DeletePoiDialogContent } from './components/poi-singolo/poi-singolo.component';
import { ListaItinerariComponent } from './pages/lista-itinerari/lista-itinerari.component';
import { ItinerarioSingoloComponent, DeleteItinDialogContent } from './components/itinerario-singolo/itinerario-singolo.component';
import { AboutComponent } from './pages/about/about.component';
import { PoiPageComponent } from './pages/poi-page/poi-page.component';
import { BreadcrumbModule } from 'angular-crumbs';
import { SinglePoiPageComponent } from './components/single-poi-page/single-poi-page.component';
import { ItineraryPageComponent } from './pages/itinerary-page/itinerary-page.component';
import { SingleItineraryPageComponent } from './components/single-itinerary-page/single-itinerary-page.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ListaUtentiComponent } from './pages/lista-utenti/lista-utenti.component';
import { MatTabsModule } from '@angular/material/tabs';
import { UtenteSingoloComponent, DeleteUserDialogContent } from './components/utente-singolo/utente-singolo.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NewPoiComponent } from './components/new-poi/new-poi.component';
import { NewItinComponent } from './components/new-itin/new-itin.component';
import { NewUserComponent } from './components/new-user/new-user.component';
import { NewThemeComponent } from './components/new-theme/new-theme.component';
import { ListaToApproveComponent } from './pages/lista-to-approve/lista-to-approve.component';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { ListaThemesComponent } from './pages/lista-themes/lista-themes.component';
import { ThemeSingoloComponent, DeleteThemeDialogContent } from './components/theme-singolo/theme-singolo.component';
import { ApprPoiSingoloComponent, DeleteApprPoiDialogContent } from './components/appr-poi-singolo/appr-poi-singolo.component';
import { ApprItinSingoloComponent, DeleteApprItinDialogContent } from './components/appr-itin-singolo/appr-itin-singolo.component';
import { AddAttachComponent } from './shared/add-attach/add-attach.component';
import { SingleAreaComponent } from './components/single-area/single-area.component';
import { FailRequestComponent } from './shared/fail-request/fail-request.component';
import { SuccessRequestComponent } from './shared/success-request/success-request.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingOverlayComponent } from './shared/loading-overlay/loading-overlay.component';
import { SingleAreaPoisResolver } from './resolvers/single-area-pois.resolver';
import { SingleAreaItinerariesResolver } from './resolvers/single-area-itineraries.resolver';
import { PoiListResolver } from './resolvers/poi-list.resolver';
import { ThemesResolver } from './resolvers/themes.resolver';
import { SinglePoiResolver } from './resolvers/single-poi.resolver';
import { ItinListResolver } from './resolvers/itin-list.resolver';
import { SingleItinResolver } from './resolvers/single-itin.resolver';
import { LoggedUserGuard } from './guards/logged-user.guard';
import { GeoPosResolver } from './resolvers/geopos.resolver';
import { AdminUserGuard } from './guards/admin-user.guard';
import { UserListResolver } from './resolvers/user-list.resolver';
import { SingleUserResolver } from './resolvers/single-user.resolver';
import { SuperadminUserGuard } from './guards/superadmin-user.guard';
import { SingleThemeResolver } from './resolvers/single-theme.resolver';
import { AddAvatarComponent } from './shared/add-avatar/add-avatar.component';
import { EditablePoiResolver } from './resolvers/editable-poi.resolver';
import { EditableItinResolver } from './resolvers/editable-itin.resolver';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { LightboxModule } from 'ngx-lightbox';
import { AddVideoComponent } from './shared/add-video/add-video.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CrudAlertComponent } from './shared/crud-alert/crud-alert.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ItinListAdminResolver } from './resolvers/itin-list-admin.resolver';
import { PoiListUnapprovedAdminResolver } from './resolvers/poi-list-unapproved-admin.resolver';
import { ItinListUnapprovedAdminResolver } from './resolvers/itin-list-unapproved-admin.resolver';
import { PoiCarouselResolver } from './resolvers/poi-carousel.resolver';
import { ItinCarouselResolver } from './resolvers/itin-carousel.resolver';
import { PoisForMapResolver } from './resolvers/pois-for-map.resolver';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavComponent,
    MapComponent,
    ListaPoiComponent,
    PoiSingoloComponent,
    ListaItinerariComponent,
    ItinerarioSingoloComponent,
    AboutComponent,
    PoiPageComponent,
    SinglePoiPageComponent,
    ItineraryPageComponent,
    SingleItineraryPageComponent,
    PageNotFoundComponent,
    LoginDialogContent,
    LogoutDialogContent,
    SuccessLoginComponent,
    ListaUtentiComponent,
    UtenteSingoloComponent,
    NewPoiComponent,
    NewItinComponent,
    NewUserComponent,
    DeleteItinDialogContent,
    DeletePoiDialogContent,
    DeleteUserDialogContent,
    ListaThemesComponent,
    ThemeSingoloComponent,
    NewThemeComponent,
    ListaToApproveComponent,
    ListaThemesComponent,
    ThemeSingoloComponent,
    ApprPoiSingoloComponent,
    ApprItinSingoloComponent,
    DeleteThemeDialogContent,
    DeleteApprPoiDialogContent,
    DeleteApprItinDialogContent,
    AddAttachComponent,
    AddVideoComponent,
    SingleAreaComponent,
    FailRequestComponent,
    SuccessRequestComponent,
    LoadingOverlayComponent,
    AddAvatarComponent,
    ChangePasswordComponent,
    CrudAlertComponent,
  ],
  entryComponents: [
    LoginDialogContent,
    LogoutDialogContent,
    SuccessLoginComponent,
    DeleteItinDialogContent,
    DeletePoiDialogContent,
    DeleteUserDialogContent,
    DeleteThemeDialogContent,
    DeleteApprPoiDialogContent,
    DeleteApprItinDialogContent,
    FailRequestComponent,
    SuccessRequestComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    NgxPaginationModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatGridListModule,
    MatTableModule,
    MatInputModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatCardModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatSelectModule,
    BreadcrumbModule,
    MatDialogModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    LightboxModule,
    MatCarouselModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      },
      defaultLanguage: 'it'
    })
  ],
  providers: [
    SingleAreaPoisResolver,
    SingleAreaItinerariesResolver,
    PoiListResolver,
    PoiCarouselResolver,
    PoiListAdminResolver,
    PoiListUnapprovedAdminResolver,
    ItinListResolver,
    ItinCarouselResolver,
    ItinListAdminResolver,
    ItinListUnapprovedAdminResolver,
    ThemesResolver,
    GeoPosResolver,
    SinglePoiResolver,
    SingleItinResolver,
    UserListResolver,
    SingleUserResolver,
    SingleThemeResolver,
    EditablePoiResolver,
    EditableItinResolver,
    LoggedUserGuard,
    AdminUserGuard,
    SuperadminUserGuard,
    PoisForMapResolver,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
